import React, { useContext, useEffect, useState } from 'react'
import { NavigationContext } from '../../context/navigation-context'
import useFetch from '../../hooks/fetchMSSQL-hook'
import moment from 'moment'
import { Link } from 'react-router-dom'
import { NotificationManager } from 'react-notifications'
import SearchFilter from '../../components/Filter/SearchFilter'

export default function MMS() {
  const { setHeaderData } = useContext(NavigationContext);
  const { fetchMssqlApi } = useFetch();
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [MMS, setMMS] = useState([]);
  const [warehouses, setWarehouses] = useState([]);

  const defaultFilter = {
    name: "MMS",
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    dateTimeRangeFrom: moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"),
    dateTimeRangeTo: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    warehouseId: null,
    warehouseName: "",
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage =
    settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  const sortDefaults = {
    WarehouseOperationFullName: "DESC",
    WarehouseOperationType: "ASC",
    WarehouseName: "ASC",
    IN: "DESC",
    RelatedDoc: "DESC",
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const fetchMMS = (force = false, currentFilter = filter) => {
    if (!settingsFilter.autoLoading && !force) return;

    if (
      !moment(currentFilter.dateTimeRangeFrom).isValid() ||
      !moment(currentFilter.dateTimeRangeTo).isValid()
    ) {
      NotificationManager.error("Wybierz poprawną datę");
      return;
    }

    fetchMssqlApi(
      "mms",
      {
        method: "POST",
        hideNotification: true,
        data: {
          fromCreateDateTime: currentFilter.dateTimeRangeFrom,
          toCreateDateTime: currentFilter.dateTimeRangeTo,
          warehouseId: currentFilter.warehouseId,
          sortBy: currentFilter.sortBy,
        },
      },
      (res) => setMMS(res || [])
    );
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
    fetchMMS(true, next);
  };

  const search = () => {
    fetchMMS(true, filter);
  };

  const getWarehouses = () => {
    fetchMssqlApi("warehouses-list", {}, (res) =>
      setWarehouses(res || [])
    );
  };

  useEffect(() => {
    setHeaderData({ text: "Przesunięcia magazynowe" });
    getWarehouses();
  }, []);

  useEffect(() => {
    if (settingsFilter.autoLoading) {
      fetchMMS(false, filter);
    }
  }, [filter]);

  const visible = MMS.slice(
    (filter.page - 1) * rowsPerPage,
    filter.page * rowsPerPage
  );

  return (
    <div>
      <SearchFilter
        filterName="MMS"
        defaultFilter={defaultFilter}
        onFilterChange={(f) =>
          setFilter((prev) => ({ ...prev, ...f }))
        }
        onSettingsChange={(s) =>
          setSettingsFilter((prev) => ({ ...prev, ...s }))
        }
        search={search}
        totalCount={MMS.length}
        dataList={MMS}
        forNow
      />

      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <div />
          <Link
            to="/mm/0"
            className="btn btn-outline-secondary mt-1 mb-1"
          >
            <i className="fas fa-plus" />
          </Link>
        </div>

        <div
          className="overflow-auto"
          style={{
            maxHeight: `${windowHeight - 100}px`,
          }}
        >
          {visible.length ? (
            <table className="table table-striped">
              <thead>
                <tr className="text-center headers-color">
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("WarehouseOperationFullName")}
                  >
                    Numer{arrow("WarehouseOperationFullName")}<br />Wystawiony
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("WarehouseOperationType")}
                  >
                    Typ{arrow("WarehouseOperationType")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("WarehouseName")}
                  >
                    Magazyn{arrow("WarehouseName")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("IN")}
                  >
                    Zamknięty{arrow("IN")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("RelatedDoc")}
                  >
                    Powiązany{arrow("RelatedDoc")}<br />Stworzony
                  </th>
                </tr>
              </thead>
              <tbody>
                {visible.map((mm) => (
                  <tr key={mm.WarehouseOperationId}>
                    <td>
                      <div className="d-flex flex-column align-items-center">
                        <Link
                          to={`/mm/${mm.WarehouseOperationId}`}
                          className="btn btn-sm btn-outline-secondary"
                        >
                          MM- {mm.WarehouseOperationId}/{mm.Created.slice(5, 7)}/{mm.Created.slice(8, 10)}
                        </Link>
                        <div className="mt-1">
                          {moment(mm.CreateDateTime).format("DD.MM.YYYY")}
                        </div>
                      </div>
                    </td>

                    <td className="text-center">
                      {mm.WarehouseOperationType}
                    </td>

                    <td className="text-center">
                      {mm.WarehouseName}
                    </td>

                    <td className="text-center">
                      {mm.IN && (
                        <Link
                          to={`/in/${mm.INId}`}
                          className="btn btn-sm btn-outline-success"
                        >
                          {mm.IN}
                        </Link>
                      )}
                    </td>

                    <td>
                      <div className="d-flex flex-column align-items-center">
                        {mm.RelatedDoc && (
                          <Link
                            to={`/mm/${mm.ToWarehouseOperationId}`}
                            className="btn btn-sm btn-outline-primary"
                          >
                            MM+ {mm.WarehouseOperationId}/{mm.Created.slice(5, 7)}/{mm.Created.slice(8, 10)}
                          </Link>
                        )}
                        <div className="mt-1">
                          {moment(mm.Created).format("DD.MM.YYYY")}
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className="h3 d-flex justify-content-center align-items-center">
              Brak danych
            </div>
          )}
        </div>
      </div>
    </div>
  );
}